import { render, staticRenderFns } from "./countPerson.vue?vue&type=template&id=6777c67e&"
import script from "./countPerson.vue?vue&type=script&lang=js&"
export * from "./countPerson.vue?vue&type=script&lang=js&"
import style0 from "./countPerson.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "countPerson.vue"
export default component.exports